import { Box, Stack, useMediaQuery } from "@mui/material";
import { TitleAtom } from "../atoms/title-atom";
import { SubtitleAtom } from "../atoms/subtitle-atom";
import { RegisterButtonAtom } from "../atoms/register-button-atom";
import { theme } from "../styles/mui-theme";
import { subtitle, titlePink, titleWhite } from "../services/titlesData";
import { redirectionFn } from "../services/redirectionFn";

export const CTAMolecule = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isWideScreen = useMediaQuery(theme.breakpoints.up("xl"));

  return (
    <Stack
      spacing={2.5}
      maxWidth={"550px"}
      justifyContent={isMobile && "center"}
      alignSelf={(isWideScreen || isMobile) && "center"}
      padding={isMobile ? "0 20px" : "0"}
    >
      <TitleAtom titleWhite={titleWhite} titlePink={titlePink} />
      <SubtitleAtom subtitle={subtitle} />
      {!isMobile && (
        <Box>
          <RegisterButtonAtom onRegisterClick={() => redirectionFn()} />
        </Box>
      )}
    </Stack>
  );
};
